import React, {useState} from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/proposition-bets-widget.module.scss";
import {TAG_TITLE} from "../../../core/app/consts";
import {CardTitle} from "../../../core/components/misc/card-tite/card-title";
import {PropositionBetsWidgetSections} from "./section/proposition-bets-widget.sections";
import {PROPOSITION_BETS} from "../proposition-bets-widgets.consts";

export const PropositionBetsWidgetBet = observer(({controller, bet, isPreview, isOpen = true}) => {
  const {state, config} = controller;
  const {title, game, sportTypeId} = state;
  const {statusGroup} = game;
  const {source} = config;
  const [isExpanded, setIsExpanded] = useState(isOpen);
  const {isUnderOver, lineTypeId} = bet;

  const sectionsProps = {
    bet,
    controller,
    isPreview,
    isExpanded
  }

  const titleProps = {
    controller,
    title: isPreview ? `${title} - ${bet.name}` : bet.name,
    className: classNames(styles.bet_title),
    tagTitle: TAG_TITLE.h3,
    onClick: !isPreview ? () => {
      sendEvent();
      setIsExpanded(!isExpanded);
    } : null
  }

  const sendEvent = () => controller.action(PROPOSITION_BETS.ANALYTICS.ACTION_TYPES.onMarketClick, {
    gameId: game.id,
    status: statusGroup,
    marketType: lineTypeId,
    clickType: !isExpanded ? PROPOSITION_BETS.ANALYTICS.CLICK_TYPE.open : PROPOSITION_BETS.ANALYTICS.CLICK_TYPE.close,
    sportTypeId,
    source,
  })

  return (
    <div className={classNames(styles.bet, {[styles.under_over_bet]: isUnderOver})}>
      <CardTitle {...titleProps}/>
      <PropositionBetsWidgetSections {...sectionsProps}/>
    </div>
  )
});
